import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'
import type {
  ProcessEmployeeDocumentMutation,
  ProcessEmployeeDocumentMutationVariables
} from './__generated__/ProcessEmployeeDocumentMutation'
import { employeeCertificateFragment } from '../fragments/EmployeeCertificateFragment'
import { employeeEducationFragment } from '../fragments/EmployeeEducationFragment'
import { employeeProfileFragment } from '../fragments/EmployeeProfileFragment'
import { employeeWorkProfileFragment } from '../fragments/EmployeeWorkProfileFragment'

const mutation: TypedDocumentNode<
  ProcessEmployeeDocumentMutation,
  ProcessEmployeeDocumentMutationVariables
> = gql`
  ${employeeCertificateFragment}
  ${employeeEducationFragment}
  ${employeeProfileFragment}
  ${employeeWorkProfileFragment}

  mutation ProcessEmployeeDocumentMutation(
    $input: ProcessEmployeeDocumentInput!
    $locale: String!
  ) {
    processEmployeeDocument(input: $input) {
      result {
        employee {
          createdAt
          educations {
            ...EmployeeEducationFragment
          }
          email
          employeeCertificates {
            ...EmployeeCertificateFragment
          }
          firstName
          gender
          id
          isStudent
          lastName
          lastSeenAt
          mobile
          ocrState
          preferredLanguage
          profile {
            ...EmployeeProfileFragment
          }
          ssn
          state
          updatedAt
          workProfile {
            ...EmployeeWorkProfileFragment
          }
        }
      }
    }
  }
`

export function processEmployeeDocumentMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      ProcessEmployeeDocumentMutation,
      ProcessEmployeeDocumentMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
